<template>
    <div class="specialized text-center">
        <i class="material-icons specialized-icon">
            {{ icon }}
        </i>
        <h3 class="specialized-title">
            {{ title }}
        </h3>
        <p class="specialized-description">
            {{ description }}
        </p>
    </div>
</template>

<script>
export default {
  name: "SpecializedItem",
  props: {
    title: String,
    icon: String,
    description: String
  }
};
</script>